/**
 * Global error boundary for consumer site tool pages.
 *
 * Catches unhandled errors and promise rejections, displays a
 * user-friendly message in the result area instead of a blank page
 * or a cryptic console error.
 *
 * Import at the top of every tool page's main.ts:
 *   import '../shared/error-boundary.ts';
 */

const ERROR_MESSAGE = `
  <div style="padding:1.5rem;border:1px solid #ef4444;border-radius:8px;background:#1a0000;color:#fca5a5;max-width:600px;margin:2rem auto;text-align:left;">
    <strong style="color:#f87171;">Something went wrong</strong>
    <p style="margin:0.75rem 0 0;font-size:0.9rem;line-height:1.5;">
      An unexpected error occurred while processing your file. This usually means:
    </p>
    <ul style="margin:0.5rem 0;padding-left:1.25rem;font-size:0.9rem;line-height:1.5;">
      <li>The file is corrupted or in an unsupported format</li>
      <li>The file is too large for your browser's memory</li>
      <li>A WebAssembly module failed to initialize</li>
    </ul>
    <p style="margin:0.75rem 0 0;font-size:0.85rem;color:#fca5a5;">
      Try a smaller file or a different format. If this keeps happening,
      <a href="mailto:support@bytario.com" style="color:#93c5fd;">contact support</a>.
    </p>
  </div>
`;

function showError(error: unknown): void {
  console.error('[Bytario] Unhandled error:', error);

  // Try to find a result/output area on the page
  const resultEl =
    document.querySelector('.result') ??
    document.querySelector('.output') ??
    document.querySelector('[data-result]') ??
    document.querySelector('main');

  if (resultEl) {
    resultEl.innerHTML = ERROR_MESSAGE;
  }
}

window.addEventListener('error', (event) => {
  showError(event.error ?? event.message);
});

window.addEventListener('unhandledrejection', (event) => {
  showError(event.reason);
});

export {};
